<template>
    <b-row>
        <b-col>
            <div @click.stop="selecionar(4)">
                <app-box
                    class="icon-button"
                    v-if="pnlVencimentos"
                    icone="fa-calendar"
                    titulo="CONTRATAÇÕES COM PRAZO ENTRE 45 E 30 DIAS"
                    corBox="success"
                    corTexto="success"
                    :selecionado="selecionado === 4"
                    >{{ pnlVencimentos.periodo4 }}</app-box
                >
            </div>
        </b-col>
        <b-col>
            <div @click.stop="selecionar(3)">
                <app-box
                    class="icon-button"
                    v-if="pnlVencimentos"
                    icone="fa-calendar"
                    titulo="CONTRATAÇÕES COM PRAZO ENTRE 29 E 15 DIAS"
                    corBox="warning"
                    corTexto="warning"
                    :selecionado="selecionado === 3"
                    >{{ pnlVencimentos.periodo3 }}</app-box
                >
            </div>
        </b-col>
        <b-col>
            <div @click.stop="selecionar(2)">
                <app-box
                    class="icon-button"
                    v-if="pnlVencimentos"
                    icone="fa-calendar"
                    titulo="CONTRATAÇÕES COM PRAZO ENTRE 14 E 7 DIAS"
                    corBox="danger"
                    corTexto="danger"
                    :selecionado="selecionado === 2"
                    @click="selecionar(2)"
                    >{{ pnlVencimentos.periodo2 }}</app-box
                >
            </div>
        </b-col>
        <b-col>
            <div @click.stop="selecionar(1)">
                <app-box
                    class="icon-button"
                    v-if="pnlVencimentos"
                    icone="fa-calendar"
                    titulo="CONTRATAÇÕES FORA DO PRAZO PARA ADITAR"
                    corBox="secondary"
                    corTexto="secondary"
                    :selecionado="selecionado === 1"
                    @click="selecionar(1)"
                    >{{ pnlVencimentos.periodo1 }}</app-box
                >
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        pnlVencimentos: {
            type: Object
        }
    },

    data() {
        return {
            selecionado: 0
        }
    },

    methods: {
        selecionar(periodo) {
            if (this.selecionado === 0 || this.selecionado != periodo) {
                this.selecionado = periodo
            } else {
                this.selecionado = 0
            }
            this.$emit('filtrar', this.selecionado)
        }
    }
}
</script>
